class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.hoverTimeout = null;
    this.openTimeout = null;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    // this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    
    // Add hover event listeners
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  onMouseEnter() {
    // Clear any existing timeouts
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
    
    // Open the menu on hover
    this.openTimeout = setTimeout(() => {
      this.open();
      this.openTimeout = null;
    }, 300);
  }

  onMouseLeave() {
    // Clear any existing timeouts
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
    
    // Add a small delay before closing to prevent flickering
    this.hoverTimeout = setTimeout(() => {
      this.close();
      this.hoverTimeout = null;
    }, 300);
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    
    // Handle click on summary to navigate if it has a data-link-url
    if (this.summary && this.summary.dataset.linkUrl) {
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
    
    // Override hover behavior for header menu
    this.removeEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.removeEventListener('mouseleave', this.onMouseLeave.bind(this));
    
    this.addEventListener('mouseenter', this.onHeaderMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onHeaderMouseLeave.bind(this));
  }

  onSummaryClick(event) {
    // Check if click is on the link text area (not the caret)
    const linkSpan = event.target.closest('.header__menu-item-link');
    const isCaretClick = event.target.closest('svg') || event.target.closest('.icon-caret');
    
    // If clicking on the link text (not caret), navigate
    if (linkSpan && !isCaretClick) {
      const url = this.summary.dataset.linkUrl;
      if (url) {
        // Allow hover to open menu, but navigate on click
        event.preventDefault();
        window.location.href = url;
      }
    }
    // Otherwise, let the default toggle behavior happen
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onHeaderMouseEnter() {
    // Clear any existing timeouts
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
    
    // Open the menu with a delay to align with close timeout
    this.openTimeout = setTimeout(() => {
      this.open();
      this.openTimeout = null;
    }, 300);
  }

  onHeaderMouseLeave() {
    // Clear any existing timeouts
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
      this.openTimeout = null;
    }
    
    // Add a small delay before closing to prevent flickering
    this.hoverTimeout = setTimeout(() => {
      this.close();
      this.hoverTimeout = null;
    }, 300);
  }
}

customElements.define('header-menu', HeaderMenu);
